/**
 * MISSPOCA 首頁動態強化 v2（2026-07-05）
 * 只加動態、不改內容。
 *   A. 首圖：滑鼠 / 捲動 / 緩慢漂移 三合一視差（rAF 驅動 transform）
 *   B. 區塊進場：淡入上移（block）＋ 圖片 clip-path 揭幕（image）
 *   C. 捲動連動縮放由 CSS 原生 scroll-timeline 處理（見 misspoca-motion.css）
 * 失效保護：主題編輯器 / 不支援 IO / 逾時 → 全部顯示，內容永不卡隱形。
 */
(function () {
  var doc = document;
  if (!doc.body || doc.body.className.indexOf('template-index') === -1) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 要淡入上移的「區塊」
  var REVEAL = [
    '.misspoca-heading-only-section', '.misspoca-split', '.misspoca-art-fragrance',
    '.misspoca-products', '.misspoca-twin-banners', '.misspoca-journal',
    '.misspoca-testimonials', '.pm-mq'
  ].join(',');

  // 要揭幕拉簾的「圖片容器」
  var WIPE = [
    '.misspoca-split-img-wrap', '.misspoca-twin-img-wrap', '.misspoca-article-img',
    '.misspoca-product-card-img', '.misspoca-pill-thumb'
  ].join(',');

  function observe(nodes, hiddenClass, shownClass) {
    if (!nodes.length) return;
    nodes.forEach(function (n) { n.classList.add(hiddenClass); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add(shownClass); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
    // 失效保護：5 秒後仍未進場的一律顯示
    setTimeout(function () { nodes.forEach(function (n) { n.classList.add(shownClass); }); }, 5000);
  }

  function run() {
    var revealNodes = Array.prototype.slice.call(doc.querySelectorAll(REVEAL));
    var wipeNodes = Array.prototype.slice.call(doc.querySelectorAll(WIPE));
    var designMode = window.Shopify && window.Shopify.designMode;

    // 首圖動態由 misspoca-hero-depth 模組負責

    // 主題編輯器或不支援 IO → 不做進場隱藏、直接顯示
    if (designMode || !('IntersectionObserver' in window)) return;

    doc.documentElement.classList.add('msp-motion');
    observe(revealNodes, 'msp-reveal', 'msp-reveal-in');
    observe(wipeNodes, 'msp-wipe', 'msp-wipe-in');
  }

  if (doc.readyState !== 'loading') run();
  else doc.addEventListener('DOMContentLoaded', run);
})();
